import AuthTokenFactory from './auth/AuthTokenFactory'
import PenaltyMasterFactory from './penaltyMaster/PenaltyMasterFactory'
import CreateLPFactory from './createLP/CreateLPFactory'
import CreateCPFactory from './createCashPenalty/CreateCPFactory'
import CreateVMISLPFactory from './createVMISLP/CreateVMISLPFactory'
import PenaltyUploadFactory from './penaltyUpload/PenaltyUploadFactory'
import UserAccessDataFactory from './userAccessData/UserAccessDataFactory'
import MasterInfoFactory from './masterInfo/MasterInfoFactory'
import PenaltyInfoFactory from './penaltyInfo/PenaltyInfoFactory'
import PenaltyGridFactory from './penaltyGrid/PenaltyGridFactory'
import PenaltyManagementFactory from './penaltyManagement/PenaltyManagementFactory'
import OrderManagementFactory from './orderManagement/OrderManagementFactory'
import UserManagementFactory from './userManagement/UserManagementFactory'
import DocumentationFactory from './documentation/DocumentationFactory'
import AdministrationFactory from './administration/AdministrationFactory'
import OrderManagementFileUploadFactory from './orderManagementFileUpload/OrderManagementFileUploadFactory'
import ReportsDetailsFactory from './reports/ReportsDetailsFactory'

const API = {
  AuthTokenRepository: AuthTokenFactory.getInstance(),
  PenaltyMasterRepository: PenaltyMasterFactory.getInstance(),
  CreateLPRepository: CreateLPFactory.getInstance(),
  CreateCPRepository: CreateCPFactory.getInstance(),
  CreateVMISLPRepository: CreateVMISLPFactory.getInstance(),
  PenaltyUploadRepository: PenaltyUploadFactory.getInstance(),
  UserAccessDataRepository: UserAccessDataFactory.getInstance(),
  MasterInfoRepository: MasterInfoFactory.getInstance(),
  PenaltyInfoRepository: PenaltyInfoFactory.getInstance(),
  PenaltyGridRepository: PenaltyGridFactory.getInstance(),
  PenaltyManagementRepository: PenaltyManagementFactory.getInstance(),
  OrderManagementRepository: OrderManagementFactory.getInstance(),
  UserManagementRepository: UserManagementFactory.getInstance(),
  DocumentationRepository: DocumentationFactory.getInstance(),
  AdministrationRepository: AdministrationFactory.getInstance(),
  OrderManagementFileUploadRepository: OrderManagementFileUploadFactory.getInstance(),
  ReportsDetailsRepository: ReportsDetailsFactory.getInstance()
}
export default API
